import mutations from "./mutations.js";
import actions from "./actions.js";
import getters from "./getters.js";

export default {
  namespaced: true,
  state() {
    return {
      languages: [
        ["IT", "Italiano", "Italia", "+39"],
        ["GB", "English", "England", "+44"],
        ["UA", "Ukrainian", "Ukraine", "+380"],
      ],
      languagesObj: [],
      onlyLangObj: [],
    };
  },
  mutations,
  actions,
  getters,
};
